import {
  contactRoles,
  contacts,
  cwsBrunoUsers,
  deleteContactResponse,
  getCategoriesList,
  getChainsList,
  getSelectedClient,
  getUserClientList,
  getUserStoresAllList,
  isLoadingCWSBrunoUsers,
  isLoadingCategories,
  isLoadingChains,
  isLoadingContactNotificationFeatures,
  isLoadingContactRoles,
  isLoadingContacts,
  isLoadingDeleteContact,
  isLoadingPatchContact,
  isLoadingPostContact,
  isLoadingRegions,
  isLoadingUpdateBrunoUser,
  isLoadingUserRoles,
  isLoadingUserStores,
  isLoadingUserSuppliers,
  notificationFeatures,
  patchContactResponse,
  postContactResponse,
  regions,
  updateBrunoUserResponse,
  userRoles,
  userSuppliers
} from 'core/selectors';
import { getChains } from 'core/slices/backend';
import { getUserRoles, updateBrunoUser } from 'core/slices/bruno';
import { deleteContact, getContactNotificationFeatures, getContactRoles, getContacts, getRegions, patchContact, postContact } from 'core/slices/contacts';
import { getStoreCategories } from 'core/slices/store';
import { getCWSBrunoUsers, getUserStores, getUserSuppliers } from 'core/slices/users';
import { connect } from 'react-redux';

import Contacts from '../../../../components/userManagement/contacts/Contacts';

export default connect(state => ({
  selectedClient: getSelectedClient(state),
  contacts: contacts(state),
  isLoadingContacts: isLoadingContacts(state),
  cwsBrunoUsers: cwsBrunoUsers(state),
  isLoadingCWSBrunoUsers: isLoadingCWSBrunoUsers(state),
  suppliers: userSuppliers(state),
  isLoadingUserSuppliers: isLoadingUserSuppliers(state),
  userRoles: userRoles(state),
  isLoadingUserRoles: isLoadingUserRoles(state),
  chains: getChainsList(state),
  isLoadingChains: isLoadingChains(state),
  userStores: getUserStoresAllList(state),
  isLoadingUserStores: isLoadingUserStores(state),
  categories: getCategoriesList(state),
  isLoadingCategories: isLoadingCategories(state),
  postContactResponse: postContactResponse(state),
  isLoadingPostContact: isLoadingPostContact(state),
  contactRoles: contactRoles(state),
  isLoadingContactRoles: isLoadingContactRoles(state),
  clients: getUserClientList(state),
  regions: regions(state),
  isLoadingRegions: isLoadingRegions(state),
  notificationFeatures: notificationFeatures(state),
  isLoadingNotificationFeatures: isLoadingContactNotificationFeatures(state),
  updateBrunoUserResponse: updateBrunoUserResponse(state),
  isLoadingUpdateBrunoUser: isLoadingUpdateBrunoUser(state),
  patchContactResponse: patchContactResponse(state),
  isLoadingPatchContact: isLoadingPatchContact(state),
  deleteContactResponse: deleteContactResponse(state),
  isLoadingDeleteContact: isLoadingDeleteContact(state),
}), {
  getContacts,
  getCWSBrunoUsers,
  getUserSuppliers,
  getUserRoles,
  getChains,
  getUserStores,
  getStoreCategories,
  postContact,
  getContactRoles,
  getRegions,
  getContactNotificationFeatures,
  updateBrunoUser,
  patchContact,
  deleteContact,
})(Contacts);